module.exports = __webpack_public_path__ + "static/media/ic_instagram.108ad477.svg";